(function () {
  'use strict';
  var configElement = document.getElementById('rt-women-offer-config');
  if (!configElement) return;
  var config;
  try { config = JSON.parse(configElement.textContent); } catch (error) { return; }
  var timer;
  var pending = false;
  var queued = false;
  var lastSignature = '';
  function update(count) {
    var visibleCount = Math.min(3, Math.max(0, count));
    document.querySelectorAll('[data-rt-women-progress]').forEach(function (panel) {
      panel.dataset.count = String(count);
      if (panel.classList.contains('rt-women-offer-progress--cart')) panel.hidden = count === 0;
      panel.querySelector('[data-rt-women-message]').textContent = config.messages[visibleCount];
      panel.querySelector('[data-rt-women-count]').textContent = config.count.replace('[count]', String(visibleCount));
      panel.querySelector('[data-rt-women-fill]').style.width = String(visibleCount * 100 / 3) + '%';
      panel.querySelector('[role="progressbar"]').setAttribute('aria-valuenow', String(visibleCount));
      var action = panel.querySelector('[data-rt-women-action]');
      action.textContent = visibleCount >= 3 ? config.viewCart : config.chooseSets;
      action.href = visibleCount >= 3 ? config.cartUrl : config.womenUrl;
    });
  }
  async function refresh() {
    if (pending) { queued = true; return; }
    pending = true;
    try {
      var response = await fetch(config.root + '?sections=rt-women-offer-status', { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) return;
      var sections = await response.json();
      if (!sections['rt-women-offer-status']) return;
      var fragment = new DOMParser().parseFromString(sections['rt-women-offer-status'], 'text/html');
      var status = fragment.querySelector('[data-rt-women-status]');
      if (status) update(Number(status.dataset.count) || 0);
    } catch (error) {
    } finally {
      pending = false;
      if (queued) { queued = false; schedule(); }
    }
  }
  function schedule() { window.clearTimeout(timer); timer = window.setTimeout(refresh, 120); }
  ['cart:updated', 'cart:change', 'cart:refresh', 'pageshow'].forEach(function (name) { window.addEventListener(name, schedule); document.addEventListener(name, schedule); });
  if (window.jQuery_T4NT) {
    window.jQuery_T4NT(document).ajaxComplete(function (event, xhr, settings) {
      if (settings && /\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(settings.url || '')) schedule();
    });
  }
  var drawer = document.querySelector('[data-cart-wrapper]');
  if (drawer) {
    new MutationObserver(function () {
      var items = drawer.querySelector('[data-cart-items]');
      var signature = items ? items.textContent + Array.from(items.querySelectorAll('input')).map(function (input) { return input.value; }).join('|') : '';
      if (signature !== lastSignature) { lastSignature = signature; schedule(); }
    }).observe(drawer, { childList: true, subtree: true, characterData: true });
  }
  update(Number(document.querySelector('[data-rt-women-progress]')?.dataset.count) || 0);
})();
